import { memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DropdownItem, useMenuDropdown } from '@shared/ui/index';
import {
  DropdownMenuWithButton,
  type DropdownMenuWithButtonPT,
} from '@shared/ui/menus/dropdown-menu/ui';

type PT = Omit<
  DropdownMenuWithButtonPT,
  'isMenuOpen' | 'onMenuBtnClick' | 'menuRef' | 'children'
> & {
  onEdit?: () => void;
  onDelete?: () => void;
  isSuccess?: boolean;
  isDeleting?: boolean;
  editText?: string;
  deleteText?: string;
  withDeleteButton?: boolean;
};
export const EditAndDeleteDropdown = memo(
  ({
    onEdit,
    onDelete,
    isSuccess,
    isDeleting,
    editText = 'Изменить',
    deleteText = 'Удалить',
    withDeleteButton = true,
    ...props
  }: PT) => {
    const { menuRef, handleAction, handleToggleDropdown, isMenuOpen } = useMenuDropdown({});

    const navigate = useNavigate();
    const doEdit = () => {
      onEdit ? onEdit() : navigate('edit');
    };
    const doDelete = () => {
      onDelete && onDelete();
    };

    useEffect(() => {
      isSuccess && navigate(-1);
    }, [isSuccess, navigate]);

    return (
      <DropdownMenuWithButton
        isMenuOpen={isMenuOpen}
        onMenuBtnClick={handleToggleDropdown}
        menuRef={menuRef}
        {...props}
      >
        <DropdownItem
          onClick={(e) => {
            e.stopPropagation();
            handleAction(doEdit)();
          }}
        >
          {editText}
        </DropdownItem>

        {withDeleteButton && (
          <DropdownItem
            disabled={isDeleting}
            onClick={(e) => {
              e.stopPropagation();
              handleAction(doDelete)();
            }}
          >
            {deleteText}
          </DropdownItem>
        )}
      </DropdownMenuWithButton>
    );
  }
);
